import * as FileSaver from 'file-saver';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DownloadFilesService {
  constructor() {}

  public downloadCSV(data: any, filename: string): void {
    const replacer = (key: any, value: any) => (value === null ? '' : value);
    // specify how you want to handle null values here

    const header = Object.keys(data[0]);

    const csv = data.map((row: any) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(';')
    );
    csv.unshift(header.join(';'));

    //"\uFEFF" para arreglar los diacríticos y las Ñ
    const csvArray = '\uFEFF' + csv.join('\r\n');

    const blob = new Blob([csvArray], {
      type: 'data:text/csv;charset=utf-8,%EF%BB%BF',
    });
    FileSaver.saveAs(blob, filename + '.csv');
  }
}
